import { FunctionComponent } from 'react';
import Image from 'next/image';
import { useRouter } from 'next/router';

import { Routes } from 'types/routes';

import Company from 'models/Company';

import { withVariables } from 'utils/string';

import PointedArrowRight from 'theme/icons/pointed-arrow-right.svg';

import Button from 'components/layout/Button';
import { ButtonIconTypes, ButtonStyles, ButtonVariants } from 'components/layout/Button/types';

import StyledComponent from './styles';
import { Props } from './types';

const BlockCompanyCard: FunctionComponent<Props> = ({ translations, company }) => {
    const router = useRouter();
    const onMoreDates = (companyCard: Company): void => {
        router.push(withVariables(Routes.PublicCompany, { slug: companyCard.slug }));
    };

    return (
        <StyledComponent className="block-company-card">
            <div className="company">
                <div className="company__image">
                    <Image
                        className="company__image__image"
                        layout='fill'
                        src={company?.images[0]?.imageUrl || '/images/home/palceholder_card_image.png'}
                        alt="card"
                        onClick={() => onMoreDates(company)}
                    />
                </div>
                <div className="company__content">
                    <div
                        className="company__content__title"
                        onClick={() => onMoreDates(company)}
                    >
                        {company?.name}
                    </div>
                    <div className="company__content__description">
                        {company?.description}
                    </div>
                    <div className="company__content__more">
                        <Button
                            style={ButtonStyles.Secondary}
                            variant={ButtonVariants.Tertiary}
                            label="Zobacz więcej"
                            icon={{
                                type: ButtonIconTypes.Image,
                                value: PointedArrowRight.src,
                                position: 'after',
                            }}
                            onClick={() => onMoreDates(company)}
                        />
                    </div>
                </div>
            </div>
        </StyledComponent>
    );
};

export default BlockCompanyCard;
